import { useEffect, type FC } from "react";
import { useLocation } from "react-router-dom";
import type { TitleProps } from "./TitleProps";

const titles: Record<string, string> = {
  "/": "Darkskies | Find dark skies you can stay under",
  "/sites": "Sites | Darkskies",
  "/windows": "Viewing windows | Darkskies",
  "/about": "About | Darkskies",
  "/contact": "Contact | Darkskies",
};

const Title: FC<TitleProps> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
      return;
    }

    document.title =
      titles[location.pathname] ?? "Darkskies | Find dark skies you can stay under";
  }, [location, title]);

  return null;
};

export default Title;
